import { z } from "zod";

import { OrganizationDtoSchema } from "../../../dtos/organizations";

export const PatchOrganizationRequestBodySchema = z.object({
  domain: z.string().optional(),
  freeTrialExpiresAtTs: z.number().optional(),
});

export type PatchOrganizationRequestBodyType = z.infer<
  typeof PatchOrganizationRequestBodySchema
>;

export const PatchOrganizationResponseBodySchema = z.object({
  org: OrganizationDtoSchema,
});

export type PatchOrganizationResponseBodyType = z.infer<
  typeof PatchOrganizationResponseBodySchema
>;
